import { render, staticRenderFns } from "./PrimarySchoolsList.vue?vue&type=template&id=5a3ac59e&scoped=true&"
import script from "./PrimarySchoolsList.vue?vue&type=script&lang=js&"
export * from "./PrimarySchoolsList.vue?vue&type=script&lang=js&"
import style0 from "./PrimarySchoolsList.vue?vue&type=style&index=0&id=5a3ac59e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a3ac59e",
  null
  
)

export default component.exports